import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import './Input.scss';

var Input = function Input(_ref) {
  var disabled = _ref.disabled,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      autocomplete = _ref.autocomplete;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  useEffect(function () {
    setInputValue(value);
  }, [value]);

  var handleOnChange = function handleOnChange(e) {
    var val = e.target.value;
    setInputValue(val);
    onChange && onChange(val);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "pwd-text-input"
  }, label && /*#__PURE__*/React.createElement("label", null, label), /*#__PURE__*/React.createElement("input", {
    disabled: disabled,
    type: type,
    name: "lastname",
    onChange: handleOnChange,
    value: inputValue,
    placeholder: placeholder,
    autoComplete: autocomplete
  }));
};

export default Input;